(function(){
var Q=window.MHTQA;if(!Q||Q.reco)return;
Q.reco=function(p,box){
var pid=p.id,qmap={};
function render(items){
items=(items||[]).filter(function(x){return x&&x.id!==pid;});
var seen={},uniq=[];items.forEach(function(x){if(x&&!seen[x.id]){seen[x.id]=1;uniq.push(x);}});
uniq=uniq.slice(0,8);if(!uniq.length)return;
box.appendChild(Q.E('div','mhtqa-recotitle','Compl\u00e9tez votre routine'));
var row=Q.E('div','mhtqa-recorow');
uniq.forEach(function(x){
var card=Q.E('div','mhtqa-recocard');
if(x.img){var im=Q.E('img','mhtqa-recoimg');im.src=x.img;im.alt=x.title;card.appendChild(im);}
card.appendChild(Q.E('div','mhtqa-recon',x.title));
card.appendChild(Q.E('div','mhtqa-recop',x.price));
var n=qmap[x.vid]||0,busy=false;
var q=Q.E('div','mhtqa-recoq'),mi=Q.E('button','mhtqa-recob','\u2212'),va=Q.E('span','mhtqa-recov',String(n)),pl=Q.E('button','mhtqa-recob mhtqa-recopl','+');
mi.type=pl.type='button';
function go(d){if(busy||(d<0&&n<=0))return;busy=true;mi.disabled=pl.disabled=true;
(d>0?Q.add(x.vid):Q.dec(x.vid,n-1)).then(function(){n+=d;va.textContent=n;Q.toast(d>0?'Produit ajout\u00e9 avec succ\u00e8s':'Produit retir\u00e9',d>0);Q.bubble();}).catch(function(){Q.toast(d>0?'Stock indisponible':'Une erreur est survenue',false);}).then(function(){busy=false;mi.disabled=pl.disabled=false;});}
mi.onclick=function(){go(-1);};pl.onclick=function(){go(1);};
q.appendChild(mi);q.appendChild(va);q.appendChild(pl);card.appendChild(q);
row.appendChild(card);
});
box.appendChild(row);
}
function related(){fetch('/recommendations/products.json?product_id='+pid+'&intent=related&limit=8').then(function(r){return r.json();}).then(function(d){render((d.products||[]).map(Q.normRec));}).catch(function(){});}
function fromCols(list){var arr=list.slice(0,2),n=arr.length,done=0,got=[];if(!n){related();return;}
arr.forEach(function(h){fetch('/collections/'+h+'/products.json?limit=10').then(function(r){return r.json();}).then(function(d){(d.products||[]).forEach(function(qq){var o=Q.normCol(qq);if(o)got.push(o);});}).catch(function(){}).then(function(){done++;if(done===n){if(got.length)render(got);else related();}});});}
function run(){fetch('/recommendations/products.json?product_id='+pid+'&intent=complementary&limit=8').then(function(r){return r.json();}).then(function(d){
if(d&&d.products&&d.products.length){render(d.products.map(Q.normRec));return;}
var c=Q.cols?Q.cols(p):null;if(c){fromCols(c);}else{related();}
}).catch(function(){var c=Q.cols?Q.cols(p):null;if(c){fromCols(c);}else{related();}});}
fetch('/cart.js').then(function(r){return r.json();}).then(function(c){(c.items||[]).forEach(function(li){qmap[li.id]=(qmap[li.id]||0)+li.quantity;});}).catch(function(){}).then(run);
};
})();